/**
 * Google Apps Script web app (POST, execute as me, anyone can invoke).
 * Full script: scripts/google-apps-webapp.gs (press count, email notify, spam guard, report triage).
 * Submit Link sends { url, nickname, timestamp } (unchanged for existing script).
 * Feedback sends { formType: "feedback", message, nickname, email, timestamp }.
 * Report sends { formType: "report", url, timestamp }.
 * Button presses: POST { formType: "button_press", source, timestamp };
 *   GET ?action=pressCount → { count: number }.
 * Link shows: POST { formType: "link_shown", url, timestamp } → LinkShows + curated Shows col.
 */
export const GOOGLE_APPS_SCRIPT_WEB_APP_URL =
  "https://script.google.com/macros/s/AKfycbyGyEcWAzO1uLH90QNqurZ4dOG6DCzVyCsw0ADauL0D7WdzKFu4n_i0fAR8dBkifE9iQw/exec";
